export default __webpack_public_path__ + "static/media/user-access.2642d370.svg";